// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"375df068","390":"81c4ed6a","448":"04f35711","453":"9a3fc660","720":"f40ef696"}[chunkId] + ".chunk.js";
};